/** Old stitches typography key -> new Tailwind .type-* class (tailwind.config.ts) */
export const TYPE_CLASS = {
  body: "type-body",
  h1: "type-title-xl",
  h2: "type-title-l",
  h3: "type-title-m",
  h4: "type-title-s",
  h5: "type-title-xs",
  "text-l": "type-body-l",
  "text-m": "type-body-m",
  "text-s": "type-body-s",
  "text-xs": "type-body-xs",
  "label-l": "type-label-l",
  "label-m": "type-label-m",
  "label-s": "type-label-s",
  caps: "type-label-caps",
} as const

export type TypeVariant = keyof typeof TYPE_CLASS
